import { Sentry } from '@/lib/sentry';

// One warning per account id per page load. A missing account is a data-integrity signal, not
// something to report once for every row that belongs to it.
const reportedAccountIds = new Set<string>();

/**
 * Reports a transaction that arrived without its owning bank account (FIN-802, EC5). The embed
 * makes this near-impossible, so an occurrence means the data or the API contract is wrong.
 */
export function reportMissingTransactionAccount(accountId: string, surface: 'table' | 'dialog') {
  if (reportedAccountIds.has(accountId)) return;
  reportedAccountIds.add(accountId);
  Sentry.captureMessage('transaction_account_label_missing', {
    level: 'warning',
    tags: { context: 'TransactionAccountLabel', surface },
    extra: { accountId },
  });
}

/** Test seam: forget which accounts were already reported. */
export function resetReportedMissingTransactionAccounts() {
  reportedAccountIds.clear();
}
